import React from "react"
import styles from "./CompareButton.module.scss"
import { usePurchase } from "../../../context/purchaseContext"
import { useUltimateAlerts } from "../../../context/ultimateAlertsContext"
import useStrings from "../../../localization/useStrings"

export const CompareButton: React.FC = () => {
  const { state: purchaseState } = usePurchase()
  const { actions: alertActions } = useUltimateAlerts()
  const strings = useStrings()

  const isUltimate = purchaseState.ultimateSelected

  const handleClick = () => {
    alertActions.setShowComparePlansSheet(true)
  }

  return (
    <button
      className={`${styles.compareButton} ${isUltimate ? styles.ultimate : styles.premium}`}
      onClick={handleClick}
    >
      {strings.comparePlans.compare}
    </button>
  )
}
